// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';

const getSiteDetails = (state) => state?.session?.siteDetails;
const getCurrencyAttributesState = (state) => getSiteDetails(state)?.currencyAttributes;

const getDefaultCurrencyAttributes = {
  exchangevalue: 1,
  merchantMargin: 1,
  roundMethod: '',
};

export const getCurrentCurrency = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails.currency;
});

export const getCurrencyAttributes = createSelector(
  getCurrencyAttributesState,
  (currencyAttributes) => {
    return currencyAttributes || getDefaultCurrencyAttributes;
  }
);

export const getCurrencyAttributesAsArray = createSelector(
  getCurrencyAttributesState,
  (currencyAttributes) => {
    const currency = currencyAttributes || getDefaultCurrencyAttributes;
    return [currency];
  }
);
